import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import API from "../axios";

const SpecsRating = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [createLoading, setCreateLoading] = useState(false);

    const [categoryName, setCategoryName] = useState();
    const [categoryKey, setCategoryKey] = useState();
    const [data, setData] = useState<any>({});
    const [ratingDatas, setRatingDatas] = useState([]);
    const [ratingValue, setRatingValue] = useState("");

    const [selectedSubCategory, setSelectedSubCategory] = useState("");
    const [selectedKey, setSelectedKey] = useState("");
    const [selectedValue, setSelectedValue] = useState<String | null>("");

    const loadExpectedResult = async () => {
        setLoading(true);

        const result: any = await API.getOneExpectedResult(id as string);
        setCategoryName(result.data.name);
        setCategoryKey(result.data.key);
        setData(result.data.json);

        loadGetRatings(result.data.key);
    };

    const loadGetRatings = async (category: string) => {
        const result: any = await API.getRatingWithCategory(category);
        setRatingDatas(result.data);
    };

    const getRatingData = function (key: string, value: string | null = null) {
        for (let index = 0; index < ratingDatas.length; index++) {
            const rating: any = ratingDatas[index];

            if (value) {
                if (rating.key == key && rating.value == value) {
                    return rating.rating || "-";
                }
            } else {
                if (rating.key == key) {
                    return rating.rating || "-";
                }
            }
        }

        return "-";
    };

    const handleUpdateRating = async function () {
        setCreateLoading(true);

        await API.createRating({
            category: categoryKey,
            subCategory: selectedSubCategory,
            key: selectedKey,
            value: selectedValue,
            rating: ratingValue,
        });

        setCreateLoading(false);
        setRatingValue("");
        loadExpectedResult();
    };

    useEffect(() => {
        loadExpectedResult();
    }, [id]);

    return (
        <div>
            <Container style={{ marginTop: 100, marginBottom: 150 }}>
                <Row>
                    <Col
                        cols="6"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <a
                            type="button"
                            className="btn btn-outline-black btn-md mx-1"
                            href={`/specs-rating-categories`}
                        >
                            <i className="bi bi-chevron-left"></i>
                        </a>
                        <h5 className="h5">Rating Of {categoryName}</h5>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" className="mt-4">
                        <div className="mb-3">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col" style={{ width: 500 }}>
                                            Sub Category
                                        </th>
                                        <th scope="col" style={{ width: 500 }}>
                                            Key
                                        </th>
                                        <th scope="col" style={{ width: 500 }}>
                                            Value
                                        </th>
                                        <th scope="col" style={{ width: 500 }}>
                                            Ratings
                                        </th>
                                        <th scope="col" style={{ width: 500 }}>
                                            Edit
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(data).map(
                                        (subCategory: string) => (
                                            <>
                                                {Object.entries(
                                                    data[subCategory]
                                                ).map(([key, value]) => (
                                                    <>
                                                        {Array.isArray(
                                                            value
                                                        ) ? (
                                                            value.map(
                                                                (v, idx) => (
                                                                    <tr
                                                                        key={
                                                                            idx
                                                                        }
                                                                    >
                                                                        <td>
                                                                            {
                                                                                subCategory
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                key
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {v}
                                                                        </td>
                                                                        <td>
                                                                            {getRatingData(
                                                                                key,
                                                                                v
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-primary btn-sm mx-1"
                                                                                onClick={() => {
                                                                                    console.log(
                                                                                        subCategory
                                                                                    );

                                                                                    setSelectedKey(
                                                                                        key
                                                                                    );
                                                                                    setSelectedValue(
                                                                                        v
                                                                                    );
                                                                                    setSelectedSubCategory(
                                                                                        subCategory
                                                                                    );
                                                                                }}
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#updateRatingModal"
                                                                            >
                                                                                <i className="bi bi-pencil"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )
                                                        ) : (
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        subCategory
                                                                    }
                                                                </td>
                                                                <td>{key}</td>
                                                                <td>-</td>
                                                                <td>
                                                                    {getRatingData(
                                                                        key
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-primary btn-sm mx-1"
                                                                        onClick={() => {
                                                                            console.log(
                                                                                subCategory
                                                                            );

                                                                            setSelectedKey(
                                                                                key
                                                                            );
                                                                            setSelectedValue(
                                                                                null
                                                                            );
                                                                            setSelectedSubCategory(
                                                                                subCategory
                                                                            );
                                                                        }}
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#updateRatingModal"
                                                                    >
                                                                        <i className="bi bi-pencil"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                ))}
                                            </>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Update rating */}
            <div
                className="modal fade"
                id="updateRatingModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Update Rating
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <label className="form-label">Rating</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter rating"
                                value={ratingValue}
                                onChange={(e) => setRatingValue(e.target.value)}
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleUpdateRating}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpecsRating;
